import { colorToCssValue } from "../../../utils/colorToCssValue";
import { IColorOverride } from "../interfaces/IColorOverride";

export const overrideColorsToCssVars = (
    colorOverrides: { name: "text" | "background"; colorOverride: IColorOverride }[]
) => {
    const css: Record<string, string> = {};
    colorOverrides.forEach((override) => {
        if (override.colorOverride.override && override.colorOverride.color) {
            css["--event-logo-override-color-" + override.name] = colorToCssValue(override.colorOverride.color);
        }
    });

    return css as React.CSSProperties;
};